module.exports = {
	'edit': 'Edit',
	'reply': 'Reply ',
	'cancel': 'Cancel',
	'submit': 'Submit',
	'tip.content': 'The length of content should be less than {{max}}',
	'content.input': 'Please fill the content',
	'rate.input': 'Please make a rate',
	'content': 'Content',
	'rate': 'Rate',
	'load.more': 'Load more',
	'no.data': 'No data',
	'use': 'useful',
	'useless': 'useless',
	'my.comment': 'My Comment',
	'summary': 'summary:',
	'comments': ' comments',
	'great': 'great',
	'good': 'good',
	'bad': 'bad',
	'sucks': 'sucks',
	'ok': 'ok',
	'owner': 'owner',
	'item': 'items'
}


// WEBPACK FOOTER //
// ./src/pages/home/i18n/locale.en.js